<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import SlidersSolid from '@/components/svg/SlidersSolid.vue';
import { usePurchaseFilters } from '@/composables/usePurchaseFilters';
import { useRentalFilters } from '@/composables/useRentalFilters';
import { ListingTypeEnum } from '@/enums/ListingType';

const props = defineProps<{
  filtersCount?: number | null,
  expanded?: boolean,
  listingType?: ListingTypeEnum
}>();

const emit = defineEmits<{
  click: []
}>();

const { t } = useI18n();
const { countSecondaryRentalFilters } = useRentalFilters();
const { countSecondaryPurchaseFilters } = usePurchaseFilters();

const handleClick = () => {
  emit('click');
};

const secondaryFiltersCount = computed(() => {
  const count = props.listingType === ListingTypeEnum.Rental ? countSecondaryRentalFilters.value : countSecondaryPurchaseFilters.value;
  return props.filtersCount || count;
});
</script>

<template>
  <button 
    @click="handleClick"
    class="rental-units-filter-button"
    type="button"
    :aria-expanded="expanded"
    aria-haspopup="dialog"
    :class="{count : secondaryFiltersCount > 0}">
    <span class="icon">
      <SlidersSolid />
    </span>
    <span class="text ">{{ t('forms.rentalFilters.filters') }}</span>
    <span v-if="secondaryFiltersCount > 0" class="filter-count">{{ secondaryFiltersCount }}</span>
  </button>
</template>

<style lang="scss" scoped>
.rental-units-filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.0rem;
  background: #ffffff;
  color: #57B84A;
  border: 1px solid #57B84A;
  border-radius: 0.8rem;
  padding: 1.4rem 2.4rem;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 15rem;

  &:hover:not(:disabled) {
    background: #4a9a3d;
    border-color: #4a9a3d;
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  span.icon{
    width:1.6rem;
    height:1.6rem;
    display:block;

    svg{
      width:100%;
      height:100%;
    } 
  } 

  .filter-count {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #403A3B;
    color: #ffffff;
    border-radius: 50%;
    width: 2.0rem;
    height: 2.0rem;
    line-height: 2.0rem;
    font-size: 1.4rem;
    font-weight: 600;
  }
}

@media screen and (max-width: 767px){
  .rental-units-filter-button{
    width: 100%;
    background: #57b84a;
    color: #fff;
    border: 1px solid #57B84A;

    .filter-count{
      background: #fff;
      color: #57b84a;
    }
  }
}
</style>